var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stripe-wrapper" }, [
    _c("div", { ref: "card" }),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.error,
            expression: "error",
          },
        ],
        staticClass: "error-msg",
      },
      [
        _c(
          "div",
          {
            staticClass: "error-close",
            on: {
              click: function ($event) {
                _vm.error = ""
              },
            },
          },
          [_vm._v("X")]
        ),
        _vm._v("\n    " + _vm._s(_vm.error) + "\n  "),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }